import React from "react";

import { observer } from "mobx-react";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";

import { CashOutFooterMessageComponent } from "./CashOutFooterMessageComponent";
import CashOutConfirmationForm from "./CashOutConfirmationForm";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
export const BetDetailsCashOutFooter = observer(
	function BetDetailsCashOutFooter(props: {
		store: BetDetailsModalStore | BetSlipReceiptModalStore;
	}) {
		const { store } = props;

		let cashoutStore: CashoutStore;

		if (store instanceof BetDetailsModalStore) {
			cashoutStore = store.myBetsStore.cashoutStore;
		} else {
			cashoutStore = store.cashoutStore;
		}

		if (!store.isCashoutOpen) {
			return null;
		}

		if (
			store.currentBet &&
			cashoutStore.cashoutModalData?.id !== store.currentBet.id
		) {
			return null;
		}

		if (!cashoutStore.cashoutModalData?.message) {
			return <CashOutConfirmationForm store={store} />;
		}

		return <CashOutFooterMessageComponent store={store} />;
	}
);
